import { createSelector } from "@reduxjs/toolkit";

import { EducatorTaskStateType } from "../../../utils";
import { StateType } from "../../../utils";

const selectTaskState = (state: StateType): EducatorTaskStateType =>
  state.educatorTaskReducer;

export const selectTasks = createSelector(
  selectTaskState,
  (state: EducatorTaskStateType) => state.tasks
);

export const selectTask = createSelector(
  selectTaskState,
  (state: EducatorTaskStateType) => state.task
);

export const selectTasksLoading = createSelector(
  selectTaskState,
  (state: EducatorTaskStateType) => state.loading
);

export const selectTasksLoaded = createSelector(
  selectTaskState,
  (state: EducatorTaskStateType) => state.loaded
);

export const selectTaskSubmitLoading = createSelector(
  selectTaskState,
  (state: EducatorTaskStateType) => state.submitLoading
);
